import ApplicationLogo from "@Core/Components/ApplicationLogo";
import { Head, Link, usePage } from "@inertiajs/react";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function GuestLayout({
    children,
    containerSize,
    backgroundImagePath,
    hideContainer = false,
    title = "",
}: {
    children: React.ReactNode;
    containerSize?: string;
    backgroundImagePath?: string;
    hideContainer?: boolean;
    title?: string;
}) {
    const { flash, page, bulletin_message, bulletin_message_type } =
        usePage().props;
    const bulletinMessageColors = {
        success: "text-green-600",
        info: "text-blue-800",
        error: "text-red-600",
    };
    const bulletinTextFont = bulletinMessageColors[bulletin_message_type] || "";

    useEffect(() => {
        if (flash && flash.message) {
            toast(flash.message, {
                type: flash.type,
            });
        }
    }, [flash]);

    return (
        <>
            <Head title={title} />
            <div className="relative flex min-h-screen flex-col items-center bg-background pt-6 sm:justify-center sm:pt-0">
                {backgroundImagePath && (
                    <div className="absolute inset-0 z-0">
                        <img
                            src={backgroundImagePath}
                            alt="Background"
                            className="h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 backdrop-blur-sm opacity-50 bg-white"></div>
                    </div>
                )}
                <div className="relative z-10 w-full max-w-2xl">
                    {page?.error && (
                        <div className="p-4 text-white text-center bg-red-600">
                            {page.error}
                        </div>
                    )}

                    {page?.success && (
                        <div className="p-4 text-white text-center bg-green-600">
                            {page.success}
                        </div>
                    )}
                </div>
                <div className="relative z-10">
                    <Link href="/">
                        <ApplicationLogo className="h-32 w-32 fill-current text-gray-500" />
                    </Link>
                </div>

                <div
                    className={`relative z-10 mt-6 w-full overflow-hidden  px-4 py-6 ${
                        containerSize
                            ? containerSize
                            : "sm:max-w-5xl" +
                              (hideContainer ? "" : " bg-white shadow-md ")
                    } sm:rounded-lg`}
                >
                    <ToastContainer
                        position="bottom-right"
                        autoClose={10000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    {typeof bulletin_message === "string" &&
                        bulletin_message.length > 0 && (
                            <section
                                className={`w-full h-full text-center ${bulletinTextFont}`}
                            >
                                {bulletin_message}
                            </section>
                        )}
                    {children}
                </div>
            </div>
        </>
    );
}
